import React, { ReactElement } from "react";
import { Tooltip, Avatar, Heading } from "@govlaunch/web";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";
import { FormattedMessage, useIntl } from "react-intl";

interface IStoryCollaboratorsProps {
  collaborators: IStoryFieldsFragment["collaborators"];
  renderLinkWrap?: (collaborator: IStoryFieldsFragment["collaborators"][0], children: ReactElement) => ReactElement;
}

export default function StoryCollaborators({ collaborators, renderLinkWrap }: IStoryCollaboratorsProps) {
  const intl = useIntl();

  return (
    <>
      <Heading as="h3" color="blue.500" fontWeight="bold" fontSize="18" mb={4}>
        <FormattedMessage defaultMessage="Collaborators" id="9Jstnt" />
      </Heading>

      <div css={{ paddingLeft: 10 }}>
        <div css={{ display: "flex", flexDirection: "column" }}>
          {collaborators.map((collaborator) => {
            const collaboratorTitle =
              collaborator.isSiteAdmin || collaborator.isLimitedSiteAdmin
                ? "Executive Producer"
                : collaborator.__typename !== "PendingUser"
                ? collaborator.title
                : collaborator.jobTitle;

            const children = (
              <div
                css={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginBottom: 10,
                }}
              >
                <div css={{ marginBottom: 4 }}>
                  <Avatar
                    src={collaborator.avatar}
                    name={collaborator.fullName || collaborator.firstName}
                    size="sm"
                    marginRight={3}
                  />
                </div>
                <span css={{ color: "gray.700", marginLeft: 10, fontSize: 16, fontWeight: 600 }}>
                  {collaborator.fullName || collaborator.firstName}
                </span>
                {typeof collaboratorTitle !== "undefined" && collaboratorTitle && collaboratorTitle.length > 0 && (
                  <span css={{ marginRight: 5 }}>, </span>
                )}
                <span css={{ color: "gray.600", fontSize: 14, fontWeight: 400 }}>{collaboratorTitle}</span>
              </div>
            );

            return (
              <Tooltip
                shouldWrapChildren={true}
                key={collaborator._id}
                label={
                  collaborator.fullName ||
                  collaborator.firstName ||
                  intl.formatMessage({ defaultMessage: "Member of Govlaunch", id: "hT39cQ" })
                }
                bg="blue.600"
                color="white"
              >
                {renderLinkWrap ? renderLinkWrap(collaborator, children) : children}
              </Tooltip>
            );
          })}
        </div>
      </div>
    </>
  );
}
